module.exports = __webpack_public_path__ + "static/media/left-img@2x.3d6c5779.png";